export default {
  tipo(state) {
    return state.tipo;
  },
  level(state) {
    return state.level;
  },
  dataInicial(state) {
    return state.dataInicial;
  },
  dataFinal(state) {
    return state.dataFinal;
  },
  hasCustomFilters(state) {
    return [
      state.tipo && state.tipo.length,
      state.level && state.level.length,
      state.dataFinal,
      state.dataInicial,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = [];
    if (state.level && state.level.length) {
      filters.push(`level in ('${state.level.join(', ')}')`);
    }
    if (state.tipo && state.tipo.length) {
      const tipoFilter = state.tipo.map(tipo => `(tipo = '${tipo}')`);
      filters.push(`(${tipoFilter.join(' or ')})`);
    }
    if (state.dataInicial) {
      filters.push(`dataExecucao >= ${state.dataInicial}`);
    }
    if (state.dataFinal) {
      filters.push(`dataExecucao <= ${state.dataFinal}`);
    }
    return filters.join(' and  ');
  },
};
